import React from "react";

const MessageIcon =  ({ className }) => (
  <svg
    className={className}
    focusable={false}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden={true}
  >
    <path d='M 11.378 15 H 19 a 1 1 0 0 0 1 -1 V 6 a 1 1 0 0 0 -1 -1 H 5 a 1 1 0 0 0 -1 1 v 8 a 1 1 0 0 0 1 1 a 1 1 0 0 1 1 1 v 3.013 L 11.378 15 z M 5 3 h 14 a 3 3 0 0 1 3 3 v 8 a 3 3 0 0 1 -3 3 h -6.958 l -6.444 4.808 A 1 1 0 0 1 4 21.006 V 17 a 2 2 0 0 1 -2 -2 V 6 a 3 3 0 0 1 3 -3 z'/>
  </svg>
);

const EditIcon = ({ className }) => (
  <svg
    className={className}
    focusable={false}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden={true}
  >
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
);

const SettingIcon = ({ className }) => (
  <svg
    className={className}
    focusable={true}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden={true}
  >
    <path
      transform="scale(1.2, 1.2)"
      d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
    />
  </svg>
);

const CameraIcon = ({ className }) => (
  <svg
    className={className}
    focusable="false"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden={true}
  >
    <circle cx="12" cy="12" r="3.2" />
    <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
  </svg>
);

const LoadingIcon = ({ className }) => (
  <div className={`loading_group ${className}`} role="progressbar">
    <circle
      className="loading_circle"
      cx="44"
      cy="44"
      r="20.2"
      fill="currentColor"
      strokeWidth="3.6"
    />
    <svg viewBox="22 22 44 44"></svg>
  </div>
);

const ReTryIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M5 18c4.667 4.667 12 1.833 12-4.042h-3l5-6 5 6h-3c-1.125 7.98-11.594 11.104-16 4.042zm14-11.984c-4.667-4.667-12-1.834-12 4.041h3l-5 6-5-6h3c1.125-7.979 11.594-11.104 16-4.041z" />
  </svg>
);

const InfoIcon = ({ className }) => (
  <svg
    className={className}
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    fill="currentColor"
    viewBox="0 0 111.577 111.577"
  >
    <g>
      <path
        d="M78.962,99.536l-1.559,6.373c-4.677,1.846-8.413,3.251-11.195,4.217c-2.785,0.969-6.021,1.451-9.708,1.451
		c-5.662,0-10.066-1.387-13.207-4.142c-3.141-2.766-4.712-6.271-4.712-10.523c0-1.646,0.114-3.339,0.351-5.064
		c0.239-1.727,0.619-3.672,1.139-5.846l5.845-20.688c0.52-1.981,0.962-3.858,1.316-5.633c0.359-1.764,0.532-3.387,0.532-4.848
		c0-2.642-0.547-4.49-1.636-5.529c-1.089-1.036-3.167-1.562-6.252-1.562c-1.511,0-3.064,0.242-4.647,0.71
		c-1.59,0.47-2.949,0.924-4.09,1.346l1.563-6.378c3.829-1.559,7.489-2.894,10.99-4.002c3.501-1.111,6.809-1.667,9.938-1.667
		c5.623,0,9.962,1.359,13.009,4.077c3.047,2.72,4.57,6.246,4.57,10.591c0,0.899-0.1,2.483-0.315,4.747
		c-0.21,2.269-0.601,4.348-1.171,6.239l-5.82,20.605c-0.477,1.655-0.906,3.547-1.279,5.676c-0.385,2.115-0.569,3.731-0.569,4.815
		c0,2.736,0.61,4.604,1.833,5.597c1.232,0.993,3.354,1.487,6.368,1.487c1.415,0,3.025-0.251,4.814-0.744
		C76.854,100.348,78.155,99.915,78.962,99.536z M80.438,13.03c0,3.59-1.353,6.656-4.072,9.177c-2.712,2.53-5.98,3.796-9.803,3.796
		c-3.835,0-7.111-1.266-9.854-3.796c-2.738-2.522-4.11-5.587-4.11-9.177c0-3.583,1.372-6.654,4.11-9.207
		C59.447,1.274,62.729,0,66.563,0c3.822,0,7.091,1.277,9.803,3.823C79.087,6.376,80.438,9.448,80.438,13.03z"
      />
    </g>
  </svg>
);

const ChartIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    // class="bi bi-clipboard-data"
    viewBox="0 0 16 16"
  >
    <path d="M4 11a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0v-1zm6-4a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0V7zM7 9a1 1 0 0 1 2 0v3a1 1 0 1 1-2 0V9z" />
    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
  </svg>
);

const ClockIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden={true}
  >
    <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" />
    <path d="M12.75 6.75h-1.5v5.69l4.36 2.6.75-1.23-3.61-2.14V6.75z" />
  </svg>
);

// 室內定位系統專用 Icons
const FloorPlanIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <rect x="3" y="3" width="18" height="18" strokeWidth="2"/>
    <line x1="3" y1="9" x2="21" y2="9" strokeWidth="2"/>
    <line x1="9" y1="9" x2="9" y2="21" strokeWidth="2"/>
  </svg>
);

const BaseStationIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <rect x="5" y="12" width="14" height="10" strokeWidth="2"/>
    <line x1="12" y1="12" x2="12" y2="4" strokeWidth="2"/>
    <line x1="9" y1="4" x2="15" y2="4" strokeWidth="2"/>
    <line x1="10" y1="6" x2="14" y2="6" strokeWidth="1.5"/>
  </svg>
);

const PersonIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <circle cx="12" cy="8" r="4" strokeWidth="2"/>
    <path d="M6 21 C6 17 8 14 12 14 C16 14 18 17 18 21" strokeWidth="2"/>
  </svg>
);

const MqttIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <path d="M 12 4 L 9 14 L 15 14 Z" strokeWidth="1.5" strokeLinejoin="round"/>
    <rect x="10" y="14" width="4" height="6" strokeWidth="1.5"/>
    <line x1="8" y1="20" x2="16" y2="20" strokeWidth="2" strokeLinecap="round"/>
    <line x1="12" y1="4" x2="12" y2="2" strokeWidth="1.5"/>
    <circle cx="12" cy="2" r="0.8" fill="currentColor"/>
    <path d="M 9 8 Q 6 8 4 10" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M 8 10 Q 6 10 5 12" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M 15 8 Q 18 8 20 10" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M 16 10 Q 18 10 19 12" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const DashboardIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
    <rect x="3" y="3" width="8" height="8" strokeWidth="2" rx="1"/>
    <rect x="13" y="3" width="8" height="8" strokeWidth="2" rx="1"/>
    <rect x="3" y="13" width="8" height="8" strokeWidth="2" rx="1"/>
    <rect x="13" y="13" width="8" height="8" strokeWidth="2" rx="1"/>
    <circle cx="7" cy="7" r="1.5" fill="currentColor"/>
    <circle cx="17" cy="7" r="1.5" fill="currentColor"/>
    <line x1="5" y1="17" x2="9" y2="17" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="7" y1="15" x2="7" y2="19" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export {
  LoadingIcon,
  EditIcon,
  CameraIcon,
  SettingIcon,
  ReTryIcon,
  InfoIcon,
  ChartIcon,
  ClockIcon,
  MessageIcon,
  FloorPlanIcon,
  BaseStationIcon,
  PersonIcon,
  MqttIcon,
  DashboardIcon,
};